import React from "react";
import { useLanguage } from "../contexts/LanguageContext";
import { trustFeatures } from "../data/trustFeatures";
import { ui } from "../data/ui";
import { Reveal } from "./Reveal";
import { SectionHeading } from "./SectionHeading";
export function TrustSignals() {
  const {
    t
  } = useLanguage();
  return <section aria-labelledby="trust-title" className="bg-charcoal py-20 lg:py-28" data-id="element-401" data-mp="tfxz4h3in2ro">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-402" data-mp="1h3xr1kckcz7u">
        <SectionHeading id="trust-title" title={t(ui.trust.title)} subtitle={t(ui.trust.subtitle)} data-id="element-403" data-mp="1h2e79jrp861b" />
        <ul className="mt-12 grid gap-5 md:grid-cols-2 lg:grid-cols-4" data-id="element-404" data-mp="1m1hcb47oic9a">
          {trustFeatures.map((feature, i) => {
          const Icon = feature.icon;
          return <li key={feature.title.en} className="h-full" data-id="element-405" data-mp="1c3jepq3xj340" data-mpi={i}>
                <Reveal delay={i * 0.05} className="flex h-full flex-col border-l-2 border-gold bg-ink p-7" data-id="element-406" data-mp="3rw8x8jxl50is">
                  <span className="grid h-12 w-12 place-items-center rounded-full border border-gold/50 text-gold" data-id="element-407" data-mp="ra782o9hf55">
                    <Icon className="h-6 w-6" aria-hidden="true" data-id="element-408" data-mp="jderunjjhtif" />
                  </span>
                  <h3 className="mt-6 text-sm font-bold uppercase tracking-[0.12em] text-white" data-id="element-409" data-mp="ef3h8alf7ez5">{t(feature.title)}</h3>
                  <p className="mt-3 text-[15px] leading-relaxed text-smoke" data-id="element-410" data-mp="seuta5sdmlai">{t(feature.text)}</p>
                </Reveal>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}